import { render, staticRenderFns } from "./QueryCard.vue?vue&type=template&id=17cf887d&scoped=true&"
import script from "./QueryCard.vue?vue&type=script&lang=js&"
export * from "./QueryCard.vue?vue&type=script&lang=js&"
import style0 from "./QueryCard.vue?vue&type=style&index=0&id=17cf887d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cf887d",
  null
  
)

export default component.exports